<template>

  <div class="card card-modal">
    <div class="row card-header">
      <div class="col-12">
        {{pageTitle}}
      </div>
    </div>

    <div class="row card-body">
      <div class="col-12">
        <p class="card-text">Numero</p>
        <the-mask id="numero" :mask="['(##) ####-####', '(##) #####-####']" v-model="form.numero" class="form-control" placeholder="Número"/>
      </div>

      <div class="col-12 ">
        <my-alert
          class="alert-danger text-center mt-3"
          @done='showError = false'
          :message ='errorMessage'
          :show='showError'
          :timeout="10000"
        ></my-alert>
      </div>
    </div>

    <div class="row card-footer">
      <div class="col-12">
        <button class="btn btn-md col-5 lg btn-danger" @click="$emit('close')">
          <font-awesome-icon icon="times" class="pointer" />
        </button>
        <button class="btn btn-md col-5 lg btn-success offset-2" @click="confirm()">
          <font-awesome-icon icon="check" class="pointer" />
        </button>
      </div>
    </div>
  </div>

</template>

<script>

export default {
  props: ['id'],
  data() {
    return {
      pageTitle: 'Cadastro de blacklist',
      form:{
        numero:''
      }
    }
  },
  async mounted() {
    if (this.id) {
      let response = await this.$http.get(`/v1/v3/nao-confiavel-v3/${this.id}`);
      if (response.success) {
        this.form = response.data;
        this.pageTitle = "Edição de blacklist";
      }
    }
  },
  methods: {
    async confirm(){
      if(this.form._id) {
        let response = await this.$http.put('/v1/v3/nao-confiavel-v3', this.form);

        if (!response.success) {
          this.errorMessage = response.err;
          this.showError = true;
        } else{
          this.$toasted.show('Número editado com sucesso', { icon: 'check', type: 'success' });
          this.$emit('close');
        }
      } else {
        let response = await this.$http.post('/v1/v3/nao-confiavel-v3', this.form);

        if (!response.success) {
          this.errorMessage = response.err;
          this.showError = true;
        } else{
          this.$toasted.show('Cadastrada com sucesso', { icon: 'check', type: 'success' });
          this.$emit('close');
        }
      }
    }
  }
};
</script>
